import { render, staticRenderFns } from "./LoadReportSettingsCard.vue?vue&type=template&id=b55f04b4&scoped=true"
import script from "./LoadReportSettingsCard.vue?vue&type=script&lang=ts"
export * from "./LoadReportSettingsCard.vue?vue&type=script&lang=ts"
import style0 from "./LoadReportSettingsCard.vue?vue&type=style&index=0&id=b55f04b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55f04b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55f04b4')) {
      api.createRecord('b55f04b4', component.options)
    } else {
      api.reload('b55f04b4', component.options)
    }
    module.hot.accept("./LoadReportSettingsCard.vue?vue&type=template&id=b55f04b4&scoped=true", function () {
      api.rerender('b55f04b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/LoadReportSettingsCard.vue"
export default component.exports